import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, NgZone } from '@angular/core';

import { AsperaService } from '../aspera/aspera.service';
import { Transfer } from './transfer.model';
import { TransferFile } from './transfer-file.model';
import { TransfersService } from './transfers.service';

@Component({
  selector: 'app-active-transfer',
  templateUrl: './active-transfer.component.html',
  styleUrls: ['./active-transfer.component.scss']
})
export class ActiveTransferComponent implements OnInit, OnDestroy {
  @Output() transferEnded = new EventEmitter<string>();
  @Input() activeFiles: TransferFile[];
  @Input() direction: string; // 'upload' or 'download'

  listener: (eventType: string, data: any) => void;
  loading: boolean = true;

  constructor(
    private ngZone: NgZone,
    private asperaService: AsperaService,
    private transfersService: TransfersService) { }

  ngOnInit() {
    this.listener = (eventType: string, data: any) => this.onTransfersUpdate(data);
    this.asperaService.addTransferListener(this.listener);
  }

  ngOnDestroy() {
    this.asperaService.removeTransferListener(this.listener);
  }

  onTransfersUpdate(data: any) {
    for (let transferInfo of data.transfers) {
      const cookie = transferInfo.transfer_spec.cookie;
      if (cookie) {
        this.onTransferUpdate(transferInfo);
        return;
      }
    }
  }

  onTransferUpdate(transferInfo: any) {
    // console.log("Transfer did update"); console.log(transferInfo);
    this.ngZone.run(() => this.loading = false);
    const status = transferInfo.status;

    switch (status) {
    case "running":
      for (let fileInfo of transferInfo.files) {
        let path = fileInfo.file;
        for (let file of this.activeFiles) {
          if (file.path === path) {
            let progress = (fileInfo.bytes_written/fileInfo.bytes_expected)*100.0;
            this.ngZone.run(() => file.progress = progress);
          }
        }
      }
      break;
    case "completed":
      for (let file of this.activeFiles) {
        this.ngZone.run(() => file.progress = 100);
      }
      setTimeout(() => this.transferEnded.emit(status), 1000);
      break;
    case "failed":
    case "canceled":
      this.transferEnded.emit(status);
      break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/transfers/active-transfer.component.ts